import { useCallback } from 'react';
import { StatusBar } from 'react-native';
import { NavigationContainer } from './NavigationContainer';
import EpaAuthProvider from '@/contexts/EpaAuthContext';

import { isPatientApp } from '@/config/constants';
import { usePrivacy } from '@/hooks/usePrivacy';

import { DialogProvider } from '@/components/ui/shared/Dialog';
import { AppShellDialogs } from '@/components/AppShellDialogs';

import { AnonymousStack } from './AnonymousStack';
import { PatientStack } from './PatientStack';
import { TherapistStack } from './TherapistStack';
import { useStoreState } from '@/stores/store';
import { PostHogEventsProvider } from '@/contexts/EventsProvider/PostHogProvider';
import { Filler } from '@/screens/Filler';

function ActiveStack({ isAuthenticated }: { isAuthenticated: boolean }) {
  const isPrivate = usePrivacy(isAuthenticated);

  return (
    <>
      {isAuthenticated && isPatientApp ? <PatientStack /> : null}
      {isAuthenticated && !isPatientApp ? <TherapistStack /> : null}
      {!isAuthenticated && <AnonymousStack />}
      {isPrivate ? <Filler /> : null}
    </>
  );
}

export function AppNavigation() {
  const { isAuthenticated } = useStoreState((store) => ({
    isAuthenticated: store.isAuthenticated,
  }));

  return (
    <NavigationContainer>
      <PostHogEventsProvider>
        <StatusBar hidden={true} translucent={true} />
        <DialogProvider>
          <AppShellDialogs />
          <EpaAuthProvider>
            <ActiveStack isAuthenticated={isAuthenticated} />
          </EpaAuthProvider>
        </DialogProvider>
      </PostHogEventsProvider>
    </NavigationContainer>
  );
}
